<template>
	<div class="freeboard-details--inner">
		<div class="freeboard-detail--wrap" :class="{'-full': !betHistory.length }">
	    <div class="post-wrap">
        <div class="post-details -date" v-if="$route.params.id !== 'new'">
          <div class="date-info--inner">
            <div class="date-info-items">
              <span class="date-info-lbl">created at</span>
              <span class="date-info-date">{{editBoard.created_at | date}}</span>
            </div>
            <div class="date-info-items">
              <span class="date-info-lbl">updated at</span>
              <span class="date-info-date">{{editBoard.updated_at | date}}</span>
            </div>
          </div>

          <div class="views-info--inner">
            <div class="date-info-items">
              <span class="date-info-lbl">views</span>
              <span class="date-info-date">{{editBoard.view_count.total}}</span>
            </div>
            <div class="date-info-items">
              <span class="date-info-lbl">deleted at</span>
              <span class="date-info-date">{{editBoard.deleted_at | date}}</span>
            </div>
          </div>
        </div>
	      <div class="post-details -user">
	        <div class="post-items -post-as"> <!-- .-post-as -->
	          <div class="post-items--lbl">
	            <span>post as</span>
	          </div>
	          <div class="post-items--data">
	            <select-list
	              :title="postAs"
	              :withReset="true"
	              v-model="postAs"
	            >
	              <select-option
	                value="test"
	                name="test user"
	              >
	                test user
	              </select-option>
	              <select-option
	                value="user"
	                name="user"
	              >
	                user
	              </select-option>
	            </select-list>
	          </div>
	        </div> <!-- .-post-as -->

	        <div class="post-items -login-data"> <!-- .-login-name -->
            <div class="post-items__login-id">
              <div class="post-items--lbl">
                <span>login id</span>
              </div>
              <div class="post-items--data">
                <input-suggestion
                  @search="searchUsers"
                  v-model="editBoard.user_id"
                  placeholder="user"
                >
                  <div slot="selected">
                    <span v-if="postUser">{{postUser}}</span>
                    <div v-if="editBoard.id  && !postUser">
                      <span v-if="editBoard.user">{{editBoard.user.login_id}}</span>
                      <span v-if="editBoard.admin">{{editBoard.admin.login_id}}</span>
                    </div>
                  </div>
                  <suggestion
                    slot="suggestion"
                    :key="user.id"
                    v-for="user in userList"
                    :value="user.id"
                  >
                    {{ user.login_id }}
                  </suggestion>
                </input-suggestion>

              </div>
            </div>

            <div class="post-items__login-name">
              <div class="post-items--lbl">
                <span>login name</span>
              </div>

              <div class="post-items--data">
                <input-suggestion
                  @search="searchUsers"
                  v-model="editBoard.user_id"
                  placeholder="user"
                >
                  <div slot="selected">
                    <span v-if="postUser">{{postUser}}</span>
                    <div v-if="editBoard.id && !postUser">
                      <span v-if="editBoard.user">{{editBoard.user.login_name}}</span>
                      <span v-if="editBoard.admin">{{editBoard.admin.login_name}}</span>
                    </div>
                  </div>
                  <suggestion
                    slot="suggestion"
                    :key="user.id"
                    v-for="user in userList"
                    :value="user.id"
                  >
                    {{ user.login_id }}
                  </suggestion>
                </input-suggestion>

              </div>
            </div>

	        </div> <!-- .-login-name -->
	      </div>

	      <div class="post-details">
	        <div class="post-items -title">
	          <div class="post-items--lbl">
	            <span>Title</span>
	          </div>

	          <div class="post-items--data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="editBoard.title"
                >
                </quill-editor>
              </div>
<!-- 	            <div class="input-wrap">
	              <input type="text" v-model="editBoard.title"/>
	            </div> -->
	          </div>
	        </div>

	        <div class="post-items -title">
	          <div class="post-items--lbl">
	            <span>image</span>
	          </div>

	          <div class="post-items--data">
	            <div class="input-wrap">
								<label for="freeboard-upload" class="post--freeboard-label">
									<button class="btn--file -withlabel">
		                <i class="ico--upload"></i>
		                <span>upload</span>
		              </button>
		              <input
		                ref="image"
		                type="file"
										id="freeboard-upload"
										class="post--freeboard-fileinput"
		                @change="attachImage"
		              >
								</label>
	            </div>
	          </div>
	        </div>
	        <div class="post-items">
	          <div class="textarea-wrap">
	            <div
	              class="post--image"
	              :style="`background-image:url(${postImage})`"
	              v-if="postImage"
	            >
	            </div>
	            <div
	              class="post--image"
	              :style="`background-image:url(${imgPath}${editBoard.image})`"
	              v-if="!postImage && editBoard.image"
	            >
	            </div>
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="editBoard.content"
                >
                </quill-editor>
              </div>
<!-- 	            <text-area
	              v-model="editBoard.content"
	              :content="editBoard.content"
	            >
	            </text-area> -->
	          </div>
	        </div>

	        <div class="post-items -checkbox">
	          <span class="post--checkbox-lbl"> comments </span>
	          <checkbox class="post--checkbox">
	            <input
	              type="checkbox"
	              v-model="editBoard.can_comment"
	            />
	          </checkbox>

	          <span class="post--checkbox-lbl"> hide </span>
	          <checkbox class="post--checkbox">
	            <input
	              type="checkbox"
	              v-model="editBoard.is_hidden"
	            />
	          </checkbox>
	        </div>
		      <button
		      	class="btn--modify -withlabel -right"
		        @click="create('editBoard')"
		        v-if="editBoard.id"
		      >
		        <i class="ico--save"></i>
		        <span>modify</span>
		      </button>
	      </div>
	    </div>

	    <freeboard-comments
	   		ref="comment"
	      v-if="editBoard.can_comment"
	      :data="editBoard"
	    >
	    </freeboard-comments>

      <button
	      class="btn--create -withlabel -right"
        @click="create('editBoard')"
        v-if="!editBoard.id"
      >
        <i class="ico--save"></i>
        <span>save</span>
      </button>
	  </div>

    <div class="freeboard-bets--wrap">
	    <div class="bet-history--inner">
	      <div class="betslip__items">
	        <betslip-card
	          v-for="(slip, index) in betHistory"
	          :key="betHistory.id"
	          :logs="slip"
	          v-if="!isDataLoading"
	          @update="update($event)"
	        >
	          <bets-card
	            v-for="(bets, idx) in slip.userBets"
	            :key="slip.userBets.id"
	            :logs="bets"
	            v-if="slip.userBets.length > 0"
	          >
	          </bets-card>
	        </betslip-card>
	      </div>
	    </div>
	  </div>
	</div>
</template>
<script type="text/javascript">
import { mapState, mapActions } from 'vuex'
import { swal } from '@/assets/js/mixins/base/Swal'

import '@/components/base/select/Select'
import '@/components/base/input/InputSuggestion.js'

import FreeboardComments from '@/views/boards/FreeboardComments'
import TextArea from '@/components/base/TextArea'
import Checkbox from '@/components/base/Checkbox'
import BetslipCard from '@/components/common/betslip/BetslipCard'
import BetsCard from '@/components/common/betslip/BetsCard'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'freeboard-details',

  components: {
    TextArea,
    Checkbox,
    FreeboardComments,
    BetslipCard,
    BetsCard,
    'quill-editor': quillEditor
  },

  mixins: [ swal ],

  computed: {
    ...mapState('freeboard-details', ['board']),
    ...mapState('test-user', { testUsers: 'users' }),
    ...mapState('user', ['users']),
    ...mapState('bet-history', ['betHistory'])
  },

  watch: {
    'editBoard.user_id' (id) {
      if (!id || !this.userList.length) return
      this.postUser = (this.userList.find((u) => {
        return u.id === id
      })).login_id
    }
  },

  created () {
    if (this.$route.params.id !== 'new') {
      this.search()
    }
  },

  data () {
    return {
      postAs: 'user',
      postImage: null,
      postUser: '',
      userList: [],

      imgPath: process.env.VUE_APP_STATIC_ASSET_PATH,

      editBoard: {
        title: '',
        content: '',
        image: null,
        can_comment: false,
        is_hidden: false,
        user_id: null,
        login_name: ''
      },

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  methods: {
    ...mapActions('freeboard-details', {
      getDetails: 'get',
      createBoard: 'create',
      updateBoard: 'update'
    }),
    ...mapActions('bet-history', ['getAttachBetslip']),
    ...mapActions('test-user', { getTestUsers: 'get' }),
    ...mapActions('user', { findUser: 'find', getUsers: 'get' }),

    async search () {
      await this.getDetails(this.$route.params.id)
      this.editBoard = JSON.parse(JSON.stringify(this.board))
      await this.getAttachBetslip({
      	request_id: this.$route.params.id,
      	type: 'freeboard'
      })
      if (this.editBoard.user && this.editBoard.user.isTester) {
      	this.postAs = 'test'
      } else {
      	this.postAs = 'user'
      }
    },

    async create (key) {
      let alertTitle = this.$route.params.id === 'new' ? 'Create Freeboard' : 'Modify Freeboard'
      let success = async () => {
        if (this.$refs.image.files.length) {
          this.editBoard.image = this.$refs.image.files[0]
        }

        if (this.editBoard.id) {
          await this.updateBoard({ id: this.editBoard.id, data: this.editBoard })
          this.$alert('success', 'Updated', '', '', 'Success')
        } else {
          this.editBoard.id = await this.createBoard(this.editBoard)
          if (this.$refs.comment) {
            this.$refs.comment.addComment()
          }
          this.$alert('success', 'Created', '', '', 'Success')
        }
      }

      //= = no need to check user. if empty, it's admin post
      // if (this.$route.params.id === 'new' && !this.editBoard.user_id) {
      //   this.$alert('error', 'Missing login name data.', {}, '', 'Error')
      //   return
      // }

      if (this.editBoard.title === '' || this.editBoard.content === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      if (this.editBoard.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.editBoard.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, alertTitle)
    },

    async searchUsers (q) {
      let params = { status: 'c', limit: 200 }

      if (q) {
        params.filter_by = 'login_id'
        params.q = q
        params.sort_by = 'id'
        params.sort = 'asc'
      }

      if (this.postAs === 'test') {
        await this.getTestUsers({ status: 'confirmed', params })
        this.userList = this.testUsers
      } else {
        await this.getUsers({ status: 'confirmed', params })
        this.userList = this.users
      }
    },

    attachImage (e) {
      if (e.target.files && e.target.files.length) {
        let fileReader = new FileReader()
        fileReader.onload = (event) => {
          this.postImage = event.target.result
        }

        fileReader.readAsDataURL(e.target.files[0])
      }
    }
  }
}
</script>
